export default "__VITE_ASSET__c7d248ec__"